import type { UpdaterRunKind, UpdaterRunStatus, UpdaterTrigger } from '@teachpartner/contracts';

const STATUS: Record<UpdaterRunStatus, { label: string; className: string }> = {
  running: { label: 'running', className: 'badge-info' },
  succeeded: { label: 'succeeded', className: 'badge-ok' },
  refused: { label: 'refused', className: 'badge-warn' },
  rolled_back: { label: 'rolled back', className: 'badge-warn' },
  failed: { label: 'failed', className: 'badge-error' },
};

const STATUS_TITLE: Record<UpdaterRunStatus, string> = {
  running: 'In progress',
  succeeded: 'Finished without errors',
  refused: 'The release failed verification; nothing changed',
  rolled_back: 'Deployed, failed the health check, previous release restored',
  failed: 'Failed; check the log (a failed rollback needs manual action)',
};

export function RunStatusPill({ status }: { status: UpdaterRunStatus }) {
  const { label, className } = STATUS[status];
  return (
    <span className={`badge ${className}`} title={STATUS_TITLE[status]}>
      {label}
    </span>
  );
}

const KIND: Record<UpdaterRunKind, string> = {
  check: 'Check',
  deploy: 'Deploy',
  rollback: 'Roll back',
};

const TRIGGER: Record<UpdaterTrigger, string> = {
  webhook: 'GitLab webhook',
  poll: 'Updater poll',
  host_admin: 'Host Admin',
  auto: 'Automatic',
};

export const kindLabel = (kind: UpdaterRunKind): string => KIND[kind];
export const triggerLabel = (trigger: UpdaterTrigger): string => TRIGGER[trigger];
